import type { TrackingConsentDetails } from '@transcend-io/airgap.js-types';
import type { LanguageRegionCode } from 'src/types'

export function hasOptedOut(locale: LanguageRegionCode, airgapConsent: TrackingConsentDetails) {
    const { Analytics, Functional, SaleOfInfo } = airgapConsent.purposes;
    return locale === 'en-US' ? !SaleOfInfo : !Analytics || !Functional || !SaleOfInfo;
}
